<template>
  <v-app
    ref="lpu-services-pagination"
    data-lpu-services-pagination
  >
    <v-pagination
      v-model="paginationModel"
      :class="isMobile ? 'py-6 mx-n2 bg-secondary' : 'pt-2'"
      :total-visible="isMobile ? 5 : 7"
      :length="pageCount"
      circle
      @input="emitRelocatePage"
    />
  </v-app>
</template>

<script>
import { PAGINATION_CONTAINER_SELECTOR } from 'www/vue_components/common/LpuServices/constants'

export default {
  name: 'LpuServicesPagination',
  props: {
    pageCount: {
      type: Number,
      default: 0,
    },
    initialPage: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      paginationModel: this.initialPage,
      currentPage: this.initialPage,
      isMobile: window.MOBILE_VERSION,
    }
  },
  watch: {
    initialPage(val) {
      this.currentPage = val
      this.paginationModel = val
    },
  },
  mounted() {
    const containerNode = document.querySelector(PAGINATION_CONTAINER_SELECTOR)

    if (containerNode) {
      containerNode.append(this.$refs['lpu-services-pagination'].$el)
    }
  },
  methods: {
    emitRelocatePage(pageNumber) {
      if (pageNumber === this.currentPage) {
        return
      }

      this.currentPage = pageNumber
      this.$emit('relocate-page:number', pageNumber)
    },
  },
}
</script>

<style lang="scss">
@import '~www/themes/doctors/common/mixins';

#app[data-lpu-services-pagination] {
  @include v-app-reset;
}
</style>
